import { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputTextarea } from "primereact/inputtextarea";

import Panel from "../../components/panel/panel";
import ExportTable from "../../components/button/ExportButton";
import { Button } from "primereact/button";
import { Link } from "react-router-dom";

const ToSendApp = () => {
  // eslint-disable-next-line no-unused-vars
  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [value, setValue] = useState("");

  const columns = [
    { field: "simulation", header: "Simulação" },
    { field: "client", header: "Cliente" },
    { field: "date", header: "Data" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const items = [
    {
      template: () => (
        <Link to={"/reports/toSendApp"} className="p-breadcrumb-link">
          Notificações
        </Link>
      ),
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const cities = [
    { name: "New York", code: "NY" },
    { name: "Rome", code: "RM" },
    { name: "London", code: "LDN" },
    { name: "Istanbul", code: "IST" },
    { name: "Paris", code: "PRS" },
  ];

  // eslint-disable-next-line no-unused-vars
  const [totalRecords, setTotalRecords] = useState(0);
  // const [customers, setCustomers] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState(null);
  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filters: {
      name: { value: "", matchMode: "contains" },
      "country.name": { value: "", matchMode: "contains" },
      company: { value: "", matchMode: "contains" },
      "representative.name": { value: "", matchMode: "contains" },
    },
  });

  const [customers, setCustomers] = useState([]); // Inicialmente, vazio

  // Simular dados de clientes (substitua isso com seus próprios dados)
  const mockCustomers = [
    { id: 1, name: "Cliente 1", country: { name: "País 1" } },
    { id: 2, name: "Cliente 2", country: { name: "País 2" } },
    // Adicione mais objetos de cliente conforme necessário
  ];

  useEffect(() => {
    // Quando o componente carregar, definir os dados simulados
    setCustomers(mockCustomers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPage = (event) => {
    setlazyState(event);
  };

  const onSort = (event) => {
    setlazyState(event);
  };

  const onFilter = (event) => {
    event["first"] = 0;
    setlazyState(event);
  };

  const onSelectionChange = (event) => {
    const value = event.value;

    setSelectedCustomers(value);
    setSelectAll(value.length === totalRecords);
  };

  const onSelectAllChange = (event) => {
    const selectAll = event.checked;

    if (selectAll) {
      setSelectAll(true);
      setSelectedCustomers(mockCustomers);
      // CustomerService.getCustomers().then((data) => {
      //   setSelectedCustomers(data.customers);
      // });
    } else {
      setSelectAll(false);
      setSelectedCustomers([]);
    }
  };
  useEffect(() => {
    if (customers) {
      // console.log(customers);
    }
  }, [customers]);

  return (
    <div className="row d-flex justify-content-between mb-3">
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <Panel title="Notificar Aplicativo">
        <div className="row d-flex mt-4">
          <div className="col-md-4 mb-3 form-group">
            <span className="p-float-label">
              <Dropdown
                inputId="dd-city"
                // value={selectedCity}
                // onChange={(e) => setSelectedCity(e.value)}
                options={cities}
                optionLabel="Nome"
                className="w-100"
              />
              <label htmlFor="dd-city">Empreendimento</label>
            </span>
          </div>
        </div>
      </Panel>

      {!visible && (
        <>
          <Panel mainCss="mt-4">
            <>
              {/* <hr className="my-4" /> */}
              <div className="px-2 pb-3">
                <ExportTable
                  tableData={customers}
                  exportColumns={exportColumns}
                  tabelaKey={"Relatório de Notificações"}
                  globalFilterValue={globalFilterValue}
                  onGlobalFilterChange={onGlobalFilterChange}
                />
                <DataTable
                  //  totalRecords={tableData.length}
                  globalFilter={globalFilterValue}
                  emptyMessage="Nenhuma Informação foi encontrada."
                  tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                  sortMode="multiple"
                  selectionMode="single"
                  rowsPerPageOptions={[5, 25, 100]}
                  value={customers}
                  lazy
                  showGridlines
                  stripedRows
                  filterDisplay="row"
                  dataKey="id"
                  paginator
                  first={lazyState.first}
                  rows={5}
                  totalRecords={totalRecords}
                  onPage={onPage}
                  onSort={onSort}
                  sortField={lazyState.sortField}
                  sortOrder={lazyState.sortOrder}
                  onFilter={onFilter}
                  filters={lazyState.filters}
                  // loading={loading}
                  selection={selectedCustomers}
                  onSelectionChange={onSelectionChange}
                  selectAll={selectAll}
                  onSelectAllChange={onSelectAllChange}
                >
                  <Column
                    selectionMode="multiple"
                    headerStyle={{ width: "3rem" }}
                  />
                  <Column
                    field="name"
                    header="Nome"
                    sortable
                    // filter
                    // filterPlaceholder="Search"
                  />
                  <Column
                    field="country.name"
                    sortable
                    header="Selecione"
                    filterField="country.name"
                    // body={countryBodyTemplate}
                    // filter
                    // filterPlaceholder="Search"
                  />
                </DataTable>
              </div>
            </>
          </Panel>

          <Panel mainCss="mt-4" title="Mensagem do Envio">
            <div className="row d-flex mt-4">
              <div className="col-md-4 mb-3 form-group">
                <span className="p-float-label">
                  <InputTextarea
                    id="description"
                    placeholder="Digite sua mensagem aqui..."
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    rows={5}
                    cols={160}
                  />
                  <label htmlFor="description">Mensagem</label>
                </span>
              </div>
              <div className="col-md-12 text-end">
                <Button label="Enviar" icon="pi pi-send" raised />
              </div>
            </div>
          </Panel>
        </>
      )}
    </div>
  );
};

export default ToSendApp;
